import { render, staticRenderFns } from "./ScreenTime.vue?vue&type=template&id=1c121ebe&scoped=true&"
import script from "./ScreenTime.vue?vue&type=script&lang=ts&"
export * from "./ScreenTime.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenTime.vue?vue&type=style&index=0&id=1c121ebe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c121ebe",
  null
  
)

export default component.exports